import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { fetchWhenReady } from 'components/ordering/csrf/pace-yourself.js'


export const CSRF_TOKEN_API = Symbol('CSRF_TOKEN_API')
export type CsrfTokenApi = {
  fetchCsrfToken: (url: URL) => Promise<unknown>
}

@registerDependency(FAKE, CSRF_TOKEN_API)
export class FakeCsrfTokenApi implements CsrfTokenApi {
  csrfToken: string | undefined = 'some-csrf-token'
  fetchedUrls: URL[] = []

  fetchCsrfToken = (url: URL) => {
    return fetchWhenReady(async () => {
      this.fetchedUrls.push(url)
      return Promise.resolve(this.csrfToken)
    })
  }
}


@registerDependency(REAL, CSRF_TOKEN_API)
export class RealCsrfTokenApi implements CsrfTokenApi {
  fetchCsrfToken = async (url: URL) => {
    return fetchWhenReady(async () => {
      const response = await fetch(url)
      if (response.ok) return response.text()
      return
    })
  }
}


export const validateReceivedToken = (value: unknown): value is string => {
  return typeof value === 'string' && value.length > 0
}
